import { FaWhatsapp } from 'react-icons/fa';
import { FiArrowRight, FiCalendar, FiUserCheck, FiUserPlus } from 'react-icons/fi';
import {
  URL_BARBERFY,
  URL_BARBERFY_LOGIN,
  URL_BARBERFY_REGISTRO,
  URL_WHATSAPP_AYUDA,
  WHATSAPP_AYUDA,
} from '../utils/barberfy';
import '../styles/Mudanza.css';

const DIRECCION = 'barberfy.com/es-es/b/barber-mujica';

const FOTOS = [
  'foto_carrusel_uno.jpeg',
  'foto_carrusel_dos.jpeg',
  'foto_carrusel_tres.jpeg',
  'foto_carrusel_cinco.jpeg',
];

const TRANQUILO = [
  {
    icono: FiUserCheck,
    titulo: 'Ya tenías cuenta aquí',
    texto:
      'Si tu cuenta tenía email, ya la hemos pasado a Barberfy. Entra con ese email (no con tu teléfono). Si no te deja entrar, pulsa «¿Olvidaste tu contraseña?» y te llega un correo para poner una nueva (mira también en spam).',
    enlace: { texto: 'Iniciar sesión en Barberfy', url: URL_BARBERFY_LOGIN },
  },
  {
    icono: FiCalendar,
    titulo: 'Tus citas siguen en pie',
    texto:
      'Las citas que ya tenías reservadas están en Barberfy con el mismo día, la misma hora y el mismo servicio. No tienes que volver a pedirlas: las verás en tu cuenta al entrar.',
    enlace: { texto: 'Ver mis citas', url: URL_BARBERFY_LOGIN },
  },
  {
    icono: FiUserPlus,
    titulo: 'Eres nuevo o no tenías email',
    texto:
      'Créate una cuenta en un minuto: tu nombre, tu email y una contraseña. Después eliges servicio, día y hora, como siempre.',
    enlace: { texto: 'Crear cuenta en Barberfy', url: URL_BARBERFY_REGISTRO },
  },
];

// Página única de la web: avisa de que las citas ahora se reservan en Barberfy.
export default function Mudanza() {
  return (
    <div className="mudanza">
      <main className="mudanza-contenido">
        <div className="mudanza-logos">
          <img src="/images/logomujica_negro.svg" alt="Barber Mujica" className="mudanza-logo-mujica" />
          <span className="mudanza-x" aria-hidden="true">×</span>
          <img src="/images/barberfy-wordmark.svg" alt="Barberfy" className="mudanza-logo-barberfy" />
        </div>

        <span className="mudanza-etiqueta">Nueva casa para tus citas</span>
        <h1>Nos mudamos a Barberfy</h1>

        <div className="mudanza-carta">
          <p>
            ¡Ey! Antes que nada, gracias por confiar en mí todo este tiempo.
          </p>
          <p>
            Desde hoy las citas se piden en <strong>Barberfy</strong>: te llega un correo con tu
            cita, un recordatorio y puedes cancelar tú mismo si te surge algo.
          </p>
          <p>
            Lo demás no cambia: mismo sitio, misma silla y el mismo cuidado en cada corte.
          </p>
          <p className="mudanza-firma">
            Un abrazo,
            <br />
            Barber Mujica
          </p>
        </div>

        <a className="mudanza-boton" href={URL_BARBERFY}>
          Reservar mi cita en Barberfy <FiArrowRight aria-hidden="true" />
        </a>
        <p className="mudanza-direccion">
          o entra en <a href={URL_BARBERFY}>{DIRECCION}</a>
          <br />
          <span>💡 Guárdala en favoritos o en la pantalla de inicio de tu móvil.</span>
        </p>

        <ul className="mudanza-fotos" aria-hidden="true">
          {FOTOS.map((foto) => (
            <li key={foto}>
              <img src={`/images/carrusel/${foto}`} alt="" loading="lazy" />
            </li>
          ))}
        </ul>

        <section className="mudanza-tranquilo">
          <h2>Lo que tienes que saber</h2>
          <div className="mudanza-rejilla">
            {TRANQUILO.map(({ icono: Icono, titulo, texto, enlace }) => (
              <div key={titulo} className="mudanza-tarjeta">
                <span className="mudanza-icono"><Icono aria-hidden="true" /></span>
                <p className="mudanza-tarjeta-titulo">{titulo}</p>
                <p>{texto}</p>
                <a className="mudanza-tarjeta-enlace" href={enlace.url}>
                  {enlace.texto} <FiArrowRight aria-hidden="true" />
                </a>
              </div>
            ))}
          </div>
        </section>

        <a className="mudanza-whatsapp" href={URL_WHATSAPP_AYUDA} target="_blank" rel="noreferrer">
          <span className="mudanza-whatsapp-icono" aria-hidden="true"><FaWhatsapp /></span>
          <span>
            <strong>¿Algo no te sale? Soporte de Barberfy</strong>
            <br />
            Escribe por WhatsApp al {WHATSAPP_AYUDA} y te ayudan paso a paso.
            <br />
            <span className="mudanza-whatsapp-horario">Atención de 9:00 a 18:00</span>
          </span>
        </a>
      </main>

      <footer className="mudanza-pie">
        © {new Date().getFullYear()} Barber Mujica · Citas con la tecnología de{' '}
        <a href="https://barberfy.com" target="_blank" rel="noreferrer">Barberfy</a>
      </footer>
    </div>
  );
}
